import { hasImageDataURISupport } from '../compat/csp';

import seasons from './config';


/**
 * returns a predicate of whether a season matches the date
 */
const seasonPredicate =
  date =>
    s => new Date(date).setMonth(s.start.month - 1, s.start.day) <= date
      && new Date(date).setMonth(s.end.month - 1, s.end.day) >= date;


/**
 * gets a season from config (if exists)
 */
export function getSeason(date) {
  if (!hasImageDataURISupport()) {
    return null;
  }

  return seasons.find(seasonPredicate(date)) || null;
}


/**
 * checks if it is a season
 */
export function isSeason(date) {
  if (!hasImageDataURISupport()) {
    return false;
  }

  return seasons.findIndex(seasonPredicate(date)) >= 0;
}


/**
 * gets season name
 */
export function whichSeason(date) {
  if (!hasImageDataURISupport()) {
    return '';
  }

  const season = getSeason(date);

  return season ? season.name : '';
}


export default { getSeason, isSeason, whichSeason };



// WEBPACK FOOTER //
// ./src/lib/seasons/index.js